import React, { useState }  from 'react';
import { PageHeader, Page, PageContent, Box, Text, Image, Heading, Tabs, Tab } from 'grommet';
import { ViewTabContent } from '../../../components/ViewTabContent';
//import Iframe from 'react-iframe';

export const LeadToCashSystems = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);


  const [activeViewTab, setActiveViewTab] = useState(0); // For the first tab section

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('../images/home-banner.png')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                      title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>HPE Landscape Display</Text>} 
                      subtitle={<Text color="black" size="xxlarge">Lead to Cash</Text>}
                      style={{ color: 'black' }}/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="medium" margin={{ top: 'large' }}>Lead To Cash Landscape and Evolution </Heading>
          <Box pad={{ bottom: '20px' }}>
          <Text weight="bold" color="red"><u>Important note:</u> need to define the target state and WORK BACK.</Text>
          </Box>
          <Tabs activeIndex={activeViewTab} onActive={setActiveViewTab} justify="start">
            <Tab title="Current State">
              <ViewTabContent>
                <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                  <Image fit="cover" src="../images/L2C-overall-v2.png"/>
                </Box>
              </ViewTabContent>
            </Tab>
            <Tab title="Transition State 1">
              <ViewTabContent>
                <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                  <Image fit="cover" src="../images/L2C-overall-tbd-t1.png"/>
                </Box>
              </ViewTabContent>
            </Tab>     
            <Tab title="Transition State 2">
              <ViewTabContent>
                <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                  <Image fit="cover" src="../images/L2C-overall-tbd-t2.png"/>
                </Box>
              </ViewTabContent>
            </Tab>    
            <Tab title="Target State (North Star)">
              <ViewTabContent>
                <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                  <Image fit="cover" src="../images/L2C-overall-tbd-ns.png"/>
                </Box>
              </ViewTabContent>
            </Tab>                                                                  
          </Tabs>

      </PageContent>  

    </Page>
  );
};